import { Component } from '@angular/core';
import { GungSettingsBaseViewComponent } from '../../gung-settings-base-view/gung-settings-base-view.component';

@Component({
  selector: 'lib-gung-settings-debug-product-view',
  templateUrl: './gung-settings-debug-product-view.component.html',
  styleUrl: './gung-settings-debug-product-view.component.scss',
  standalone: false
})
export class GungSettingsDebugProductViewComponent extends GungSettingsBaseViewComponent {}
